import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/elpriser/se4")({
  head: () => seoHead("/elpriser/se4"),
  beforeLoad: () => permanentRedirect("/elpriser/elomrade-4"),
});
